import PortalIdParser from 'PortalIdParser';
import Raven from 'raven-js';
import { getDimensionColumn, normalizeCrmColumns, setDataColumns } from './columnUtils';
import { OBJECT_TYPE_ID_TO_TABLE_GROUP } from './constants';
import { CONTACTS } from '../constants/dataTypes';
import { getInboundDbReportWithMeasures, getInboundDbReportWithMeasuresAndProvidedDimension } from './defaultReportUtils';
import { addFiltersToReport, normalizeCrmFilters, addSearchTermToReport } from './filterUtils';
// @ts-expect-error Untyped import
import { isBlocklistedForAggregation } from '../public/blocklisted-for-aggregation';
import { getIsPreviousReportValidAsBase } from './existingReportUtils';
const normalizeAndUpdateReportFilterAndDataColumns = (report, filters, dataType, columns, searchTerm) => {
  const normalizedFilters = normalizeCrmFilters(filters);
  const normalizedColumns = normalizeCrmColumns(dataType, columns);
  const reportWithFilters = addFiltersToReport(report, normalizedFilters);
  const nextReport = addSearchTermToReport(reportWithFilters, searchTerm);
  return setDataColumns(normalizedColumns, nextReport);
};
const filterNonReportableColumns = (dataType, columns, propertyMetadata) => {
  return columns.filter(column => {
    const property = propertyMetadata.get(column.name || '');
    const isReportableProperty = property && !isBlocklistedForAggregation(dataType, false, property);
    return isReportableProperty;
  });
};
export const buildReportConfigFromCRMView = ({
  startingReport: previousReport,
  objectTypeId,
  propertyMetadata,
  columns: startingColumns,
  filters,
  dimensionColumnProperty,
  viewName,
  searchTerm
}) => {
  const dataType = OBJECT_TYPE_ID_TO_TABLE_GROUP[objectTypeId] || objectTypeId;
  const columns = propertyMetadata ? filterNonReportableColumns(dataType, startingColumns, propertyMetadata) : startingColumns;
  const dimension = getDimensionColumn(columns, dimensionColumnProperty);
  try {
    const report = dimension ? getInboundDbReportWithMeasuresAndProvidedDimension(dataType, dimension, viewName) : getInboundDbReportWithMeasures(dataType, viewName);
    const prevReportValid = getIsPreviousReportValidAsBase(previousReport, columns, dataType);
    const baseReport = prevReportValid ? previousReport : report;
    return normalizeAndUpdateReportFilterAndDataColumns(baseReport, filters, dataType, columns, searchTerm);
  } catch (e) {
    Raven.captureException(e, {
      tags: {
        errorBoundary: 'CREATE_FROM_CRM'
      }
    });
    try {
      return getInboundDbReportWithMeasures(dataType || CONTACTS);
    } catch (nestedError) {
      Raven.captureException(nestedError, {
        tags: {
          errorBoundary: 'CREATE_FROM_CRM'
        }
      });
      return getInboundDbReportWithMeasures(CONTACTS);
    }
  }
};
export const openReportInSorb = (objectTypeId, columns, filters, dimensionColumnProperty) => {
  const storageKey = 'open_report_in_sorb';
  const dataType = OBJECT_TYPE_ID_TO_TABLE_GROUP[objectTypeId];
  const reportConfig = buildReportConfigFromCRMView({
    objectTypeId,
    columns,
    filters,
    dimensionColumnProperty
  }).toJS();
  try {
    const encodedData = JSON.stringify(reportConfig);
    window.localStorage.setItem(storageKey, encodedData);
  } catch (error) {
    console.error('Failed to write report config to localstorage');
    throw error;
  }
  window.open(`/report-builder/${PortalIdParser.get()}/create-report/${dataType}`, '_blank');
};